import React, { useState, useEffect } from 'react';
import { Button, Grid, Paper } from "@material-ui/core";
import { createStyles, makeStyles, Theme, withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { getBookingOverview } from "../../actions/GenomicsResearchAction";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Link } from "react-router-dom";
import { textAlign } from '@mui/system';
// import "./dashboard.css";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        card: {
            height: "100%",
            padding: "20px",
        },
        cardContent: {
            textAlign: "center",
        },
        center: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
        text: { color: "black" },
    })
);
const StyledTableCell: any = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: "#12145e",
            color: theme.palette.common.white,
            fontSize: "14px",
        },
        body: {
            fontSize: 14,
        },
    })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
    createStyles({
        root: {
            "&:nth-of-type(odd)": {
                backgroundColor: theme.palette.action.hover,
            },
        },
    })
)(TableRow);


interface Props {
    getBookingOverview: any;
    bookingoverview: any;
    userDetails: any;
    loading: any
}

const Dashboard: React.FC<Props> = ({
    getBookingOverview,
    bookingoverview,
    loading,
}) => {
    const classes = useStyles();
    const [selectedOption, setSelectedOption] = useState(null);
    const handleWGSClick = (option: any) => {
        if (selectedOption === option) {
            setSelectedOption(null); // Toggle off the selected option
        } else {
            setSelectedOption(option);
        }
    };
    return (
        <div style={{ width: "100%", margin: "60px auto" }}>
            <div style={{ backgroundColor: "#0b2857", border: "2px solid #0b2857", borderRadius: "10px" }}>
                <h2 style={{ textAlign: "center", color: "white" }}>2022-2023</h2>
            </div>
            <div style={{ margin: "10px 0px 0px 0px" }} id="geno">
                <div className="cardsAppointment" style={{ display: 'flex', flexDirection: 'row', alignItems: "flex-start" }}>
                    <div onClick={() => handleWGSClick("WGS of rice")} style={{ width: '400px' }}>
                        <Grid container>
                            <Grid item sm={12}>
                                <h5 style={{ color: "#ffffff", fontWeight: 'bold' }}>WGS of Rice</h5>
                                <span style={{ color: "#ffffff", fontWeight: 'bold' }}>Sample: 500</span><br />
                            </Grid>
                        </Grid>
                    </div>

                    {/* <div style={{ color: "white", textAlign: "center" }}>Project ID:SO-08-22-574</div> */}
                    <div onClick={() => handleWGSClick("WGS of wheat")} style={{ width: '400px' }}>
                        <Grid container>
                            <Grid item sm={12}>
                                <h5 style={{ color: "#ffffff", fontWeight: 'bold' }}>WGS of wheat</h5>
                                <span style={{ color: "#ffffff", fontWeight: 'bold' }}>Samples: 42</span><br />
                            </Grid>
                        </Grid>
                    </div>
                    <div onClick={() => handleWGSClick("SEQ of rice")} style={{ width: '400px' }}>
                        <Grid container>
                            <Grid item sm={12}>
                                <h5 style={{ color: "#ffffff", fontWeight: 'bold' }}>RNA-SEQ of rice</h5>
                                <span style={{ color: "#ffffff", fontWeight: 'bold' }}>Samples: 58</span><br />
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </div>

            {/* Render the content when selectedOption is not null */}
            {selectedOption === "WGS of rice" && (
                <div>
                    <>
                        <Paper>
                            <Grid container spacing={2} style={{ fontWeight: "bold", fontSize: "15px", marginTop: "-20px" }} className="pml-marginLeft-c">
                                <Grid item xs={6}>
                                    <Grid item xs={12}>
                                        <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                            <Grid item xs={4}>
                                                Project Title
                                            </Grid>
                                            <Grid item xs={8}>
                                                : WGS of Rice
                                            </Grid>
                                        </div>
                                        <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                            <Grid item xs={4}>
                                                Abstract
                                            </Grid>
                                            <Grid item xs={8}>
                                                : 500 rice samples were sequenced and 68K markers were identified
                                            </Grid>
                                        </div>
                                        <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                            <Grid item xs={4}>
                                                Aim of the experiment
                                            </Grid>
                                            <Grid item xs={8}>
                                                : Identification of 68K markers from the samples
                                            </Grid>
                                        </div>
                                        <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                            <Grid item xs={4}>
                                                Funded By
                                            </Grid>
                                            <Grid item xs={8}>
                                                :pkminfo lifeScience pvt ltd.
                                            </Grid>
                                        </div>
                                    </Grid>
                                </Grid>
                                <Grid item xs={6}>
                                    <Grid item xs={12}>
                                        <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                            <Grid item xs={5}>
                                                Name of the PI/Co PI
                                            </Grid>
                                            <Grid item xs={7}>
                                                : Dr. Ravi
                                            </Grid>
                                        </div>
                                        <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                            <Grid item xs={5}>
                                                Status
                                            </Grid>
                                            <Grid item xs={7}>
                                                : Completed
                                            </Grid>
                                        </div>
                                        <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                            <Grid item xs={5}>
                                                Closure Date
                                            </Grid>
                                            <Grid item xs={7}>
                                                : March 2023
                                            </Grid>
                                        </div>
                                        <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                            <Grid item xs={5}>
                                                Closure Remarks
                                            </Grid>
                                            <Grid item xs={7}>
                                                : Successful
                                            </Grid>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Paper>
                        <Paper style={{ marginTop: "10px" }}>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        style={{ width: "100%", background: "#1e4357", color: "white" }}
                                        onClick={() =>
                                            window.open(
                                                "https://static-redcliffelabs.s3.ap-south-1.amazonaws.com/media/betatest/2023/6/26/1687773446190_SampleList.xlsx",
                                                "_blank"
                                            )
                                        }
                                    >
                                        Download Sample List
                                    </Button>
                                </Grid>
                                <Grid item xs={6}>
                                    <Link to={`/dashboard/gnre/genom_samples_report`} style={{ textDecoration: "none" }}>
                                        <Button
                                            variant="contained"
                                            type="submit"
                                            style={{ width: "100%", background: "#1e4357", color: "white" }}
                                        >
                                            Sample Report
                                        </Button>
                                    </Link>
                                </Grid>
                            </Grid>
                        </Paper>

                    </>
                </div>
            )
            }

            {
                selectedOption === "WGS of wheat" && (
                    <Paper>
                        <Grid container spacing={2} style={{ fontWeight: "bold", fontSize: "15px", marginTop: "-20px" }} className="pml-marginLeft-c">
                            <Grid item xs={6}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={4}>
                                            Project Title
                                        </Grid>
                                        <Grid item xs={8}>
                                            : WGS of wheat
                                        </Grid>
                                    </div>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={4}>
                                            Abstract
                                        </Grid>
                                        <Grid item xs={8}>
                                            : 42 wheat samples
                                        </Grid>
                                    </div>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={4}>
                                            Aim of the experiment
                                        </Grid>
                                        <Grid item xs={8}>
                                            : Identification of 8K markers from the samples
                                        </Grid>
                                    </div>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={4}>
                                            Funded By
                                        </Grid>
                                        <Grid item xs={8}>
                                            : pkminfo lifeScience pvt ltd.
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid item xs={6}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={5}>
                                            Name of the PI/Co PI
                                        </Grid>
                                        <Grid item xs={7}>
                                            : Dr. Ravi
                                        </Grid>
                                    </div>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={5}>
                                            Status
                                        </Grid>
                                        <Grid item xs={7}>
                                            : Pending
                                        </Grid>
                                    </div>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={5}>
                                            Closure Date
                                        </Grid>
                                        <Grid item xs={7}>
                                            : Aug 2023
                                        </Grid>
                                    </div>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={5}>
                                            Closure Remarks
                                        </Grid>
                                        <Grid item xs={7}>
                                            : Pending
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                )
            }
            {
                selectedOption === "SEQ of rice" && (
                    <Paper>
                        <Grid container spacing={2} style={{ fontWeight: "bold", fontSize: "15px", marginTop: "-20px" }} className="pml-marginLeft-c">
                            <Grid item xs={6}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={5}>
                                            Name of the PI/Co PI
                                        </Grid>
                                        <Grid item xs={7}>
                                            :
                                        </Grid>
                                    </div>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={5}>
                                            Status
                                        </Grid>
                                        <Grid item xs={7}>
                                            :
                                        </Grid>
                                    </div>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={5}>
                                            Name of the authors/Co authors
                                        </Grid>
                                        <Grid item xs={7}>
                                            :
                                        </Grid>
                                    </div>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={5}>
                                            Closure Date
                                        </Grid>
                                        <Grid item xs={7}>
                                            :
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                )
            }

        </div >
    );
};

const mapStateToProps = (state: any) => ({
    bookingoverview: state.GenomicsCAReducer.bookingoverview,
    loading: state.GenomicsCAReducer.loading,
});

export default connect(mapStateToProps, {
    getBookingOverview,
})(Dashboard);